import { Chip } from "./Chip";

export function ChipList({
  items,
  shown = 2,
  variant = "default",
}: {
  items: string[];
  shown?: number;
  variant?: "default" | "mono";
}) {
  if (items.length === 0) {
    return <span className="text-sm text-foreground/70">None</span>;
  }

  const hidden = items.length - shown;

  return (
    <span
      className="flex flex-wrap items-center gap-1"
      title={items.join(", ")}
    >
      {items.slice(0, shown).map((item, index) => (
        <Chip key={index} variant={variant}>
          {item}
        </Chip>
      ))}
      {hidden > 0 && (
        <span className="text-xs tabular-nums text-foreground/70">
          +{hidden}
        </span>
      )}
    </span>
  );
}
